import React, { useEffect, useState } from 'react';
import logoWhite from './assets/images/harlan-logo-white.png';
import { HomePage } from './pages/HomePage';
import { ShowsPage } from './pages/ShowsPage';
import { MediaPage } from './pages/MediaPage';
import { EpkPage } from './pages/EpkPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { AdminPage } from './pages/AdminPage';
import { navItems } from './data';
import { AuthProvider } from './lib/auth';
import { AppLink, navigate, usePathname } from './routing';

const pages: Record<string, { title: string; element: React.ReactNode }> = {
  '/': { title: 'Harlan | Country Band', element: <HomePage /> },
  '/about': { title: 'About | Harlan', element: <AboutPage /> },
  '/shows': { title: 'Shows | Harlan', element: <ShowsPage /> },
  '/media': { title: 'Media | Harlan', element: <MediaPage /> },
  '/epk': { title: 'EPK | Harlan', element: <EpkPage /> },
  '/contact': { title: 'Contact | Harlan', element: <ContactPage /> },
  '/admin': { title: 'Admin | Harlan', element: <AdminPage /> },
};

function App() {
  const pathname = usePathname();
  const page = pages[pathname] ?? pages['/'];
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (hash && pages[`/${hash}`]) {
      navigate(`/${hash}`);
    }
  }, []);

  useEffect(() => {
    document.title = page.title;
    window.scrollTo({ top: 0, behavior: 'auto' });
    setMenuOpen(false);
  }, [pathname, page.title]);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  const isAdmin = pathname === '/admin';

  return (
    <AuthProvider>
      <div className={isAdmin ? 'page admin-page' : 'page'}>
        {isAdmin ? null : (
          <header className={`top-nav${menuOpen ? ' is-open' : ''}`}>
            <AppLink className="brand" href="/">
              <img src={logoWhite} alt="Harlan logo" />
              <div className="brand-text">
                <span className="tagline">Country as good as it once was.</span>
              </div>
            </AppLink>
            <button
              className="menu-toggle"
              type="button"
              aria-expanded={menuOpen}
              aria-controls="site-nav"
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <span />
              <span />
              <span />
            </button>
            <nav id="site-nav">
              {navItems.map((item) => (
                <AppLink
                  key={item.href}
                  className={pathname === item.href ? 'is-active' : undefined}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </AppLink>
              ))}
              <AppLink className="pill nav-cta" href="/contact" onClick={() => setMenuOpen(false)}>
                Book the Band
              </AppLink>
            </nav>
          </header>
        )}

        <main>{page.element}</main>

        {isAdmin ? null : (
          <footer className="footer">
            <AppLink className="brand mini" href="/">
              <img src={logoWhite} alt="Harlan logo" />
              <div className="brand-text">
                <span className="tagline">California Country</span>
              </div>
            </AppLink>
            <div className="footer-links">
              {navItems.map((item) => (
                <AppLink key={item.href} href={item.href}>
                  {item.label}
                </AppLink>
              ))}
            </div>
            <p className="meta">Built for buyers, promoters, and fans who love 90’s country done right.</p>
          </footer>
        )}
      </div>
    </AuthProvider>
  );
}

export default App;
